// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PageTopSvg from '@rsuite/icon-font/lib/direction/PageTop';
var PageTop = createSvgIcon({
    as: PageTopSvg,
    ariaLabel: 'page top',
    category: 'direction',
    displayName: 'PageTop'
});
export default PageTop;
